import { atom } from 'jotai';

export const pkListAtom = atom([]);

export const setLocalPkListValue = (data, callback, type = 'toggle') => {
  const { brandId, brandName, kindId, kindName, myid, modelName, thumb, price, modelYearId, year } = data;
  let newobj
  newobj = {
    brandId,
    brandName,
    kindId,
    kindName,
    myid: myid || modelYearId,
    modelName,
    thumb,
    price,
    year,
    isChecked: true,
  };

  return (get, set) => {
    try {
      const initialData = get(pkListAtom);

      const hasDuplicateId = initialData.some(item => Number(item.myid) === Number(newobj.myid));

      // 如果已存在，不处理
      let updatedData = [...initialData];

      const checkedCount = initialData.filter(item => item.isChecked).length; // 过滤选中项
      const isChecked = checkedCount < 10; // 判断是否小于 10
      newobj.isChecked = isChecked;

      // 根据操作类型执行不同逻辑
      if (type === 'add' && !hasDuplicateId) {
        updatedData = [newobj, ...initialData];
      } else if (type === 'toggle') {
        updatedData = hasDuplicateId
          ? initialData.filter(item => Number(item.myid) !== Number(newobj.myid))
          : [newobj, ...initialData];
      }


      !!updatedData && localStorage.setItem('globalPkComparison', JSON.stringify(updatedData));
      callback?.(updatedData);
      set(pkListAtom, updatedData);
    } catch (error) {
      console.log(error);
    }
  };
};

export const initPkListAtom = atom(get => get(pkListAtom));

export const pkComparisonAtom = atom(
  (get) => get(initPkListAtom),
  async (get, set, params: any = {}) => {
    const { data, callback, type } = params;
    const updateFn = setLocalPkListValue(data, callback, type);
    updateFn(get, set);
  }
);
